import React from "react";

export const AdminOperationLogTableHead = React.memo(function AdminOperationLogTableHead() {
    return (
        <thead>
            <tr>
                <th>No.</th>
                <th></th>
                <th>対象</th>
                <th>種類</th>
                <th>操作前</th>
                <th>操作後</th>
                <th>日時</th>
            </tr>
        </thead>
    );
});
